import { ChromatogramSeries } from "./chromatogram_series.js";
export class ChromatogramSeries1D extends ChromatogramSeries {
    constructor(array, options) {
        super(array, 1, options);
    }
    dataToJson() {
        return Array.from(this.getData());
    }
}
//# sourceMappingURL=chromatogram_series_1d.js.map